import colors from '@colors'
import loginImage from '@images/login-image.jpg'
import {Stack, Button, styled, keyframes} from '@mui/material'

export const ContentContainer = styled(Stack)(({theme}) => ({
  width: '100vw',
  height: '100vh',
  backgroundColor: theme.palette.primary.main,
  justifyContent: 'space-evenly',
  flexDirection: 'row',
}))

export const LeftContentContainer = styled(Stack)(({theme}) => ({
  padding: '5rem 2rem',
  width: '50%',
  alignItems: 'center',
  color: theme.palette.common.white,
  justifyContent: 'space-between',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },
}))

export const WelcomeMessageContainer = styled(Stack)(() => ({
  width: '20rem',
  paddingTop: '2rem',
  alignItems: 'flex-start',
}))

export const LoginButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '2rem',
  width: '20rem',
  height: '2.5rem',
  marginTop: '1rem',
  color: theme.palette.grey[100],
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.common.white,
  },
}))

export const HcsLoginButton = styled(Button)(({theme}) => ({
  backgroundColor: '#2596be',
  borderRadius: '2rem',
  width: '16rem',
  height: '2rem',
  marginTop: '0.5rem',
  textTransform: 'none',
  color: theme.palette.common.white,
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.common.white,
  },
}))

const fadeInRight = keyframes`
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

export const RightContentContainer = styled(Stack)(({theme}) => ({
  width: '50%',
  backgroundImage: `url(${loginImage})`,
  margin: '2rem',
  backgroundColor: '#12294494',
  borderRadius: '3rem',
  backgroundSize: 'cover',
  backgroundPositionX: '50%',
  opacity: 0,

  animation: `${fadeInRight} 1s cubic-bezier(0.4, 0, 0.2, 1) forwards`,
  willChange: 'opacity, transform',

  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}))

export const RightContentOverlay = styled(Stack)(() => ({
  backgroundColor: '#12294494',
  width: '100%',
  height: '100%',
}))

export const InfoText = styled(Stack)(() => ({
  maxWidth: '19rem',
  paddingTop: '1rem',
}))

const fadeInUpBlur = keyframes`
  from {
    opacity: 0;
    transform: translateY(6px);
    filter: blur(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }
`

export const imageStyle = {
  height: '70px',
  width: '220px',

  opacity: 0,
  willChange: 'opacity, transform, filter',
  animation: `${fadeInUpBlur} 500ms ease-out forwards`,
  animationDelay: '0.75s',

  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
    opacity: 1,
    filter: 'none',
    transform: 'none',
  },
}

export const customInputStyle = {
  backgroundColor: '#FFFFFF1A',
  borderRadius: '2rem',
  width: '20rem',
  color: colors.common.white,
  '& :hover': {
    border: 'none',
  },
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`
export const LeftContentInputsWrapper = styled(Stack)(() => ({
  height: '100%',
  justifyContent: 'center',
  gap: 15,

  opacity: 0,
  animation: `${fadeIn} 2.75s ease-out forwards`,
  animationDelay: '0.25s',

  willChange: 'opacity',

  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
    opacity: 1,
  },
}))
